import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFTextField } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Icon } from '@iconify/react';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';
import { closeCashRegisterSchema } from './validations';
import { defaultValuesForm } from './initial-values';

type Props = {
  current?: any;
  isEdit?: boolean;
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function PopCashRegister({ isEdit = false, onSave, isLoading, current }: Props) {
  const { isOpen, box } = useCashRegisterContext();
  const { palette } = useTheme();

  const defaultValues = useMemo(
    () => defaultValuesForm(current),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [current]
  );

  const methods = useForm<any>({
    defaultValues,
    resolver: yupResolver(closeCashRegisterSchema),
  });

  const { reset, handleSubmit, control } = methods;

  const onSubmit = async (data: any) => {
    const { cash, creditCard, transference, ...rest } = data;
    const payments = [
      {
        type: 'cash',
        payValue: cash,
      },
      {
        type: 'card',
        payValue: creditCard,
      },
      {
        type: 'bank',
        payValue: transference,
      },
    ];
    try {
      await onSave({ ...rest, payments, atmUser: box?.actmUserOpen?.uid, cashRegisterId: box?.id });
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if ((isEdit && current) || !isEdit) {
      reset(defaultValues as unknown as Partial<any>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, current]);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: isOpen ? 2 : 0 }}>
        <Icon icon="vaadin:cash" color={palette.info.main} width={100} />
      </Box>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="cash"
          label="Efectivo"
          type="number"
          isZero
          placeholder="Dinero en efectivo"
          control={control}
        />
        <RHFTextField
          name="creditCard"
          label="Datafono"
          type="number"
          isZero
          placeholder="Dinero en Datafono"
          control={control}
        />
        <RHFTextField
          name="transference"
          label="Tranferencias"
          type="number"
          isZero
          placeholder="Dinero en Transferencias"
          control={control}
        />
      </Stack>
      <Stack sx={{ px: 3, gap: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="comment"
          label="Comentarios"
          placeholder="Escribe la razon del cambio de metodo de pago"
          control={control}
        />
      </Stack>
      <Stack sx={{ justifyContent: 'center', my: isOpen ? 2 : 0 }}>
        <LoadingButton type="submit" variant="outlined" loading={isLoading}>
          Guardar cambios
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
